import { Avatar, Collapse, withWidth } from "@material-ui/core";
import moment from "moment-timezone";
import React from "react";
import {
  IZYTableCell,
  IZYTableRow,
} from "../../../components/CustomStyles/CustomTable";
import Img from "../../../components/Img";
import { formatCurrency } from "../../../components/Utils/Currency";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import { css, cx } from "emotion";
import { Skeleton } from "@material-ui/lab";

const user = JSON.parse(localStorage.getItem("user"));
const ListRow = ({
  transaction_delivery,
  number,
  status,
  handleChat,
  handleOpenFormStart,
  handleOpenFormComplete,
  action,
}) => {
  const property = transaction_delivery?.property;
  const delivery_group = transaction_delivery?.delivery_groups[0];
  const delivery_package = delivery_group?.delivery_package;
  const transaction = transaction_delivery?.transaction;
  const orders = delivery_group?.orders;
  const delivery_logs = delivery_group?.delivery_logs?.map(
    (value, key) => value
  );
  const reverseLogs = delivery_logs.reverse();

  const [openRow, setOpenRow] = React.useState(false);

  return (
    <React.Fragment>
      <IZYTableRow>
        <IZYTableCell>
          <span className="font-12">{number}</span>
        </IZYTableCell>
        <IZYTableCell>
          <span className="d-block font-bold font-12">
            {transaction?.customer_address?.consignee_firstname +
              " " +
              transaction?.customer_address?.consignee_lastname || "Recipient"}
          </span>
          <span className="d-block text-muted font-10">
            {transaction?.unique_id}
          </span>
        </IZYTableCell>
        <IZYTableCell className="text-center">
          <Img
            src={delivery_group?.delivery_package?.vendor?.image || ""}
            width={60}
            style={{ borderRadius: 4 }}
          />
        </IZYTableCell>
        <IZYTableCell>
          <div className="d-flex justify-content-start align-items-center flex-wrap w-100">
            {delivery_group?.orders?.map((order, index) => (
              <Img
                src={order?.tenant?.logo?.square}
                width={26}
                height={26}
                style={{ marginRight: 8, borderRadius: 4 }}
                key={index}
              />
            ))}
          </div>
        </IZYTableCell>
        <IZYTableCell>
          <span className="d-block font-bold font-12 text-success">
            {formatCurrency(
              property?.currency,
              delivery_group?.delivery_fee?.toString()
            )}
          </span>
          {delivery_package?.is_manual && delivery_package?.is_cod && (
            <span className="badge badge-warning">COD</span>
          )}
        </IZYTableCell>
        <IZYTableCell>
          <span className="d-block font-12 font-bold text-primary">
            {moment(transaction.create_time)
              .tz(property?.timezone)
              .format("MMM Do YYYY")}
          </span>
          <span className="d-block font-12">
            {moment(transaction.create_time)
              .tz(property?.timezone)
              .format("HH:mm:ss z")}
          </span>
        </IZYTableCell>
        <IZYTableCell className="text-right">
          {transaction?.user?.phone &&
            transaction?.user?.phone !== "" &&
            user?.type === "staff" && (
              <button
                type="button"
                className="btn btn-wa ml-2"
                onClick={() => handleChat(transaction_delivery)}
              >
                <span>
                  <WhatsAppIcon style={{ width: 17, height: 17 }} />
                </span>
              </button>
            )}
          {status?.action?.process && (
            <button type="button" className="btn btn-order-process ml-2">
              <span>
                {status?.action?.process?.label}{" "}
                <ArrowForwardIosIcon
                  style={{ width: 10, height: 10, marginLeft: 15 }}
                />
              </span>
            </button>
          )}
          {delivery_package?.is_manual &&
            delivery_group?.delivery_st === "waiting" &&
            action?.patch &&
            action?.update && (
              <button
                type="button"
                className="btn btn-order-process ml-2"
                onClick={() => handleOpenFormStart(transaction_delivery)}
              >
                <span>
                  Start Delivery
                  <ArrowForwardIosIcon
                    style={{ width: 10, height: 10, marginLeft: 15 }}
                  />
                </span>
              </button>
            )}
          {delivery_package?.is_manual &&
            delivery_group?.delivery_st === "process" &&
            action?.patch &&
            action?.update && (
              <button
                type="button"
                className="btn btn-order-process ml-2"
                onClick={() => handleOpenFormComplete(transaction_delivery)}
              >
                <span>
                  Complete Delivery
                  <ArrowForwardIosIcon
                    style={{ width: 10, height: 10, marginLeft: 15 }}
                  />
                </span>
              </button>
            )}
          <button
            type="button"
            className="btn btn-white ml-2"
            onClick={() => setOpenRow(!openRow)}
          >
            <span>{openRow ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}</span>
          </button>
        </IZYTableCell>
      </IZYTableRow>
      <IZYTableRow>
        <IZYTableCell colSpan={7} style={{ padding: 0, border: "none" }}>
          <Collapse
            in={openRow}
            timeout="auto"
            unmountOnExit
            style={{ backgroundColor: "#FAFAFA", padding: 2 }}
          >
            <div className="row w-100">
              <div className="col-md-6 col-12 border-right-2-secondary pr-0">
                <div className="row mx-0 border-bottom-1-secondary">
                  <div className="col-md-7 col-12 p-3 border-right-1-secondary d-flex justify-content-start align-items-center">
                    <div>
                      <span className="font-12 text-gray-757575 d-block">
                        Delivery number
                      </span>
                      <span className="font-12 font-bold text-primary d-block">
                        {delivery_group?.delivery_agent &&
                          `[${delivery_group?.delivery_agent}] `}{" "}
                        {delivery_group?.delivery_ref_no}
                      </span>
                      <span className="font-12 text-primary d-block">
                        {delivery_group?.delivery_id}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-5 col-12 p-2">
                    <div
                      className={cx(
                        css`
                          background-color: #4caf50;
                          border-radius: 8px;
                          color: #ffffff;
                        `,
                        "p-3"
                      )}
                    >
                      {!delivery_group?.estimate_fee && (
                        <div>
                          <span className="font-12 text-white d-block">
                            Delivery Fee
                          </span>
                          <span className="font-16 font-bold text-white d-block">
                            {formatCurrency(
                              property?.currency,
                              delivery_group?.delivery_fee?.toString()
                            )}
                          </span>
                        </div>
                      )}
                      {delivery_group?.estimate_fee && (
                        <div>
                          <span className="font-12 text-white d-block">
                            Estimate Fee
                          </span>
                          <span className="font-16 font-bold text-white d-block">
                            {formatCurrency(
                              property?.currency,
                              delivery_group?.estimate_fee?.toString()
                            )}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row mx-0">
                  <div className="col-12 py-3">
                    <h4 className="font-bold font-12">Daftar Pesanan</h4>
                    {orders?.length > 0 &&
                      orders?.map((order, index) => (
                        <React.Fragment key={index}>
                          <div className="w-100 d-flex justify-content-start align-items-center">
                            <Img
                              src={order?.tenant?.logo?.square}
                              style={{ width: 26, height: 26 }}
                            />
                            <span className="font-12 font-bold text-blue ml-3">
                              {order?.tenant?.name}
                            </span>
                            <span className="font-12 text-blue ml-1">
                              ({order?.sub_total_item} Item)
                            </span>
                          </div>
                          {order?.items?.map((item, index) => (
                            <div
                              className={
                                index === 0
                                  ? "d-flex w-100 justify-content-start align-items-start py-3"
                                  : "d-flex w-100 justify-content-start align-items-start py-3 border-top-1-secondary"
                              }
                              key={index}
                            >
                              <Img
                                src={item.main_image || item.image_urls[0]}
                                style={{ width: 36, height: 36 }}
                              />
                              <div className="ml-3">
                                <span className="font-10 text-gray-757575 d-block">
                                  {order?.tenant?.name}
                                </span>
                                <span className="font-12 font-bold d-block mb-1">
                                  {item?.name}
                                </span>
                                <span className="font-10 d-block">
                                  {item.qty} Item x{" "}
                                  {formatCurrency(
                                    property?.currency,
                                    (item.discounted_price &&
                                    item.discounted_price > 0
                                      ? item.discounted_price
                                      : item.price.value
                                    ).toString()
                                  )}
                                </span>
                                {item?.note && item?.note !== "" && (
                                  <span className="font-10 d-block">
                                    Note = {item?.note}
                                  </span>
                                )}
                              </div>
                              <div
                                className="ml-auto text-left"
                                style={{ width: "30%" }}
                              >
                                <span className="font-10 text-gray-757575 d-block">
                                  Product Price
                                </span>
                                <span className="font-12 d-block">
                                  {formatCurrency(
                                    property?.currency,
                                    (item.discounted_price &&
                                    item.discounted_price > 0
                                      ? item.discounted_price * item.qty
                                      : item.price.value * item.qty
                                    ).toString()
                                  )}
                                </span>
                              </div>
                            </div>
                          ))}
                          <div className="d-flex w-100 justify-content-start align-items-start py-3">
                            <div style={{ width: 36, height: 36 }}></div>
                            <div
                              className="ml-3 w-100 rounded-8px p-2"
                              style={{ backgroundColor: "#EEEEEE" }}
                            >
                              <table className="table table-no-border w-100">
                                <tbody>
                                  <tr>
                                    <td
                                      width="60%"
                                      className="p-2 font-10 text-gray-757575"
                                    >
                                      Total Harga ({order?.items?.length}{" "}
                                      Produk)
                                    </td>
                                    <td
                                      width="40%"
                                      className="border-left-1-d8d8d8 p-2 pl-4 font-10 font-bold text-gray-757575 text-left"
                                    >
                                      {formatCurrency(
                                        property?.currency,
                                        (
                                          order.sub_total_amount -
                                          order.service_charge_amount -
                                          order.tax_charge_amount
                                        ).toString()
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      width="60%"
                                      className="p-2 font-10 text-gray-757575"
                                    >
                                      Service (
                                      {order?.tenant?.service_charge_percentage}
                                      %)
                                    </td>
                                    <td
                                      width="40%"
                                      className="border-left-1-d8d8d8 p-2 pl-4 font-10 font-bold text-gray-757575 text-left"
                                    >
                                      {formatCurrency(
                                        property?.currency,
                                        order.service_charge_amount.toString()
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      width="60%"
                                      className="p-2 font-10 text-gray-757575"
                                    >
                                      Tax (
                                      {order?.tenant?.tax_charge_percentage}%)
                                    </td>
                                    <td
                                      width="40%"
                                      className="border-left-1-d8d8d8 p-2 pl-4 font-10 font-bold text-gray-757575 text-left"
                                    >
                                      {formatCurrency(
                                        property?.currency,
                                        order.tax_charge_amount.toString()
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      width="60%"
                                      className="p-2 font-10 text-gray-757575"
                                    >
                                      Total
                                    </td>
                                    <td
                                      width="40%"
                                      className="border-left-1-d8d8d8 p-2 pl-4 font-10 font-bold text-success text-left"
                                    >
                                      {formatCurrency(
                                        property?.currency,
                                        order.sub_total_amount.toString()
                                      )}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </React.Fragment>
                      ))}
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div
                  className={cx(
                    css`
                      background-color: #2196f3;
                      border-radius: 8px;
                      color: #ffffff;
                    `,
                    "p-3"
                  )}
                >
                  <p className="font-12 font-bold mb-2">Shipping Address</p>
                  <h4 className="font-16 mb-0">{`${transaction?.customer_address?.consignee_firstname} ${transaction?.customer_address?.consignee_lastname}`}</h4>
                  <p className="font-12 font-bold mb-3">
                    {transaction?.customer_address?.prefix_phone}{" "}
                    {transaction?.customer_address?.consignee_phone}
                  </p>
                  <p className="font-10">
                    {transaction?.customer_address?.detail_address} <br />
                    {`${transaction?.customer_address?.subdistrict?.name}, ${transaction?.customer_address?.district?.name}, ${transaction?.customer_address?.province?.name}`}{" "}
                    <br /> {transaction?.customer_address?.zip_code}
                  </p>
                </div>
                {delivery_group?.delivery_courier &&
                  delivery_group?.delivery_courier?.name && (
                    <div
                      className={cx(
                        css`
                          background-color: #ff9800;
                          border-radius: 8px;
                          color: #ffffff;
                        `,
                        "p-3 mt-3"
                      )}
                    >
                      <p className="font-12 font-bold mb-2">Courier/Driver</p>
                      <h4 className="font-16 mb-0">
                        {delivery_group?.delivery_courier?.name}
                      </h4>
                      <p className="font-12 font-bold">
                        {delivery_group?.delivery_courier?.phone}
                      </p>
                      <p className="font-12 font-bold">
                        {delivery_group?.delivery_courier?.vehicle}
                      </p>
                    </div>
                  )}
                <p className="font-10 font-bold mt-3 mb-2">Status Pengiriman</p>
                <ul className="vertical-timeline">
                  {reverseLogs?.map((log, key) => (
                    <li
                      className={key === 0 ? "my-2 active" : "my-2"}
                      key={key}
                    >
                      <div className="d-flex flex-column justify-content-start align-items-start ml-3 w-100">
                        <span
                          className={
                            key === 0
                              ? "font-10 text-primary"
                              : "font-10 text-muted"
                          }
                        >
                          {moment(log?.time)
                            .tz(property?.timezone)
                            .format("DD MMM, YYYY H:mm z")}
                        </span>
                        <span className="font-12 text-primary my-1">
                          {log?.description}
                        </span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Collapse>
        </IZYTableCell>
      </IZYTableRow>
    </React.Fragment>
  );
};

const ListRowLoading = () => {
  return (
    <IZYTableRow>
      <IZYTableCell>
        <span className="font-12">
          <Skeleton width={10} />
        </span>
      </IZYTableCell>
      <IZYTableCell>
        <span className="d-block font-bold font-12">
          <Skeleton width={150} />
        </span>
        <span className="d-block text-muted font-10">
          <Skeleton width={170} />
        </span>
      </IZYTableCell>
      <IZYTableCell className="text-center">
        <Skeleton width={60} height={60} />
      </IZYTableCell>
      <IZYTableCell>
        <div className="d-flex justify-content-start align-items-center flex-wrap w-100">
          <Skeleton width={26} height={26} />
          <Skeleton width={26} height={26} />
          <Skeleton width={26} height={26} />
        </div>
      </IZYTableCell>
      <IZYTableCell>
        <span className="font-bold font-12 text-success">
          <Skeleton width={70} />
        </span>
      </IZYTableCell>
      <IZYTableCell>
        <span className="d-block font-12 font-bold text-primary">
          <Skeleton width={70} />
        </span>
        <span className="d-block font-12">
          <Skeleton width={90} />
        </span>
      </IZYTableCell>
      <IZYTableCell className="text-right">
        <Skeleton width={41} heighy={22} />
      </IZYTableCell>
    </IZYTableRow>
  );
};

const ListRowPanel = withWidth()(ListRow);
const ListRowLoadingPanel = withWidth()(ListRowLoading);
export { ListRowPanel, ListRowLoadingPanel };
